import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  {
    apiName: "avsAllowed",
    component: "FrmCheckbox",
    visibleIfSetting: "paymentsBoarded",
  },
  {
    apiName: "cvvAllowed",
    component: "FrmCheckbox",
    visibleIfSetting: "paymentsBoarded",
  },
  {
    apiName: "paymentNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.PAYMENT.fullString,
    hasInputLabel: true,
  },
  {
    apiName: "companyName",
    component: "FrmTextField",
    visibleIfSetting: "paymentsBoarded",
  },
  {
    apiName: "template",
    component: "FrmFormTemplates",
    visibleIfSetting: "paymentsBoarded",
  },
  {
    apiName: "paymentNotifyEmail",
    component: "FrmTextField",
    maxLength: 255,
  },
];
